import { useQuery } from '@tanstack/react-query';
import { Card } from '@atoms/Card';
import { Badge } from '@atoms/Badge';
import { Spinner } from '@atoms/Spinner';
import { adminService } from '@services/adminService';
import type { SystemStatus } from '@/types';

const STATUS_LABELS: Record<string, string> = {
  ok: 'Çalışıyor',
  error: 'Hata',
  connected: 'Bağlı',
  disconnected: 'Bağlı Değil',
};

function StatusBadge({ value }: { value: string }) {
  const variant =
    value === 'ok' || value === 'connected' ? 'success' : value === 'disconnected' ? 'warning' : 'danger';
  return <Badge variant={variant}>{STATUS_LABELS[value] ?? value}</Badge>;
}

export function SystemStatusSection() {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['admin', 'system-status'],
    queryFn: () => adminService.getSystemStatus(),
    refetchInterval: 30000,
  });

  if (isLoading) return <Spinner />;

  const services: { key: keyof SystemStatus; label: string }[] = [
    { key: 'api', label: 'API' },
    { key: 'database', label: 'Veritabanı' },
    { key: 'redis', label: 'Redis' },
    { key: 'meilisearch', label: 'Meilisearch' },
    { key: 'whatsapp', label: 'WhatsApp' },
  ];

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Sistem Durumu</h1>
          <p className="mt-1 text-sm text-slate-500">Servis sağlık kontrolü</p>
        </div>
        <button type="button" onClick={() => refetch()} className="text-sm text-brand-600 hover:underline">
          Yenile
        </button>
      </div>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {services.map(({ key, label }) => (
          <Card key={key} className="flex items-center justify-between">
            <span className="font-medium">{label}</span>
            <StatusBadge value={data?.[key] ?? 'error'} />
          </Card>
        ))}
      </div>
    </div>
  );
}
